import React, { useEffect, useState } from "react";
import CollectionCard from "../../components/home/collection-card";
import Collection1 from "../../images/collection 1.png";
import Collection2 from "../../images/collection 2.png";
import PML from "../../images/PML_Logo.png";
import { SettingsApi } from "../../api/methods-marketplace";

const Collection = () => {
  const [tradableCount, setTradableCount] = useState(null);
  const [nonTradableCount, setNonTradableCount] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);
  const fetchSettings = async () => {
    try {
      const settings = await SettingsApi();

      const tradable_count = settings?.data?.tradable
        ? settings?.data.tradable
        : null;
      const non_tradable_count = settings?.data?.non_tradable
        ? settings?.data.non_tradable
        : null;

      setTradableCount(tradable_count);
      setNonTradableCount(non_tradable_count);
    } catch (err) {
      console.log("🚀 ~ fetchSettings ~ err:", err);
    }
  };
  const collections = [
    {
      title: "BAF Fractionated RWAs NFT Collection",
      type: "tradable",
      typeShow: "Tradable",
      description:
        "Exclusive collection featuring limited-edition RWAs in collaboration with Rocketbyz. Exclusive collection featuring limited-edition RWAs in collaboration with Rocketbyz.",
      nftCount: tradableCount,
      imgSrc: Collection1
    },
    {
      title: "Rocketbyz x BAF Limited RWA Collection",
      type: "non_tradable",
      typeShow: "Non-Tradable",
      description:
        "Exclusive collection featuring limited-edition RWAs in collaboration with Rocketbyz. Exclusive collection featuring limited-edition RWAs in collaboration with Rocketbyz.",
      nftCount: nonTradableCount,
      imgSrc: Collection2
    }
  ];

  return (
    <div className="bg-white-900 py-12">
      <div className="px-4">
        <div className="max-w-7xl mx-auto">
          <div className="section-title flex flex-col gap-2.5 mb-8">
            {/* <img className="h-[auto] w-[15.625rem]" src={PML} alt="PML_logo" /> */}
            <h1 className="text-2xl sm:text-4xl font-semibold font-bruno tracking-[0.3rem] text-black">
              COLLECTIONS
            </h1>
          </div>

          <div className="flex flex-col gap-8">
            {collections.map((collection, index) => (
              <CollectionCard key={index} {...collection} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Collection;
